import type { ClickTweenFunction, ElementTweenFunction, ScrollTweenFunction } from './types'; // Add ClickTweenFunction

import { dotClick } from './tweens/dotClick';
import { dropFromTop } from './tweens/dropFromTop';
import { enterFromBottom } from './tweens/enterFromBottom';
import { exitToBottom } from './tweens/exitToBottom'; // Import the new exit tween
// Import the individual tweens
import { fadeIn } from './tweens/fadeIn';
import { fadeInDot } from './tweens/fadeInDot';
import { fadeOut } from './tweens/fadeOut'; // Import fadeOut
import { fullscreenClick } from './tweens/fullscreenClick';
import { makeBordersTransparent } from './tweens/makeBordersTransparent';
import { pulse } from './tweens/pulse'; // Import the new pulse tween
import { scroll } from './tweens/scroll';
import { scrollCards } from './tweens/scrollCards';
import { scrollContinuous } from './tweens/scrollContinuous';
import { setImageToCover } from './tweens/setImageToCover';
import { setMetaToM23Green } from './tweens/setMetaToM23Green';

// Note: setMetaTagColor is imported in setMetaToM23Green.ts now







// Export the tween library
export const tweenLibrary: {
	element: { [key: string]: ElementTweenFunction };
	scroll: { [key: string]: ScrollTweenFunction };
	click: { [key: string]: ClickTweenFunction }; // Add click category
} = { scroll: {}, element: {}, click: {} }; // Initialize click category

/**
 * Registers a tween or timeline from JSON data into the tween library.
 * @param json - The JSON data defining the tween or timeline.
 */
// export function registerTweenFromJson(json: TweenDefinitionJson): void {
//     const tweenFunction: ElementTweenFunction = ({ target, options, scrollTrigger }
//     ) => {
//         if (json.timeline) {
//             // Handle timeline
//             const tl = gsap.timeline();
//             for (const tween of json.timeline) {
//                 const mergedProps = { ...tween.properties, ...options };
//                 if (tween.type === 'to') {
//                     tl.to(target, mergedProps);
//                 } else if (tween.type === 'from') {
//                     tl.from(target, mergedProps);
//                 }
//             }
//             if (scrollTrigger?.trigger) {
//                 ScrollTrigger.create({ animation: tl, ...scrollTrigger });
//             }
//             return tl;
//         }
//         if (json.type && json.properties) {
//             // Handle single tween
//             const mergedProps = { ...json.properties, ...options };
//             let animation: gsap.core.Tween;
//             if (json.type === 'to') {
//                 animation = gsap.to(target, mergedProps);
//             } else if (json.type === 'from') {
//                 animation = gsap.from(target, mergedProps);
//             } else {
//                 throw new Error(`Unsupported tween type: ${json.type}`);
//             }
//             if (scrollTrigger?.trigger) {
//                 ScrollTrigger.create({ animation, ...scrollTrigger });
//             }
//             return animation;
//         }
//         throw new Error('Invalid JSON: Must define either "type" and "properties" or "timeline".');
//     };

//     tweenLibrary[json.elementType][json.name] = tweenFunction;
// }


// Initialize the library with the imported tweens
tweenLibrary.element.destroyFirstPage = () => { return { tween: void 0 } }; // Placeholder for a tween that does nothing
tweenLibrary.element.dropFromTop = dropFromTop;
tweenLibrary.element.enterFromBottom = enterFromBottom;
tweenLibrary.element.exitToBottom = exitToBottom; // Register exitToBottom
tweenLibrary.element.fadeIn = fadeIn;
tweenLibrary.element.fadeOut = fadeOut; // Register fadeOut
tweenLibrary.element.fadeInDot = fadeInDot;
tweenLibrary.element.makeBordersTransparent = makeBordersTransparent;
tweenLibrary.element.pulse = pulse; // Register pulse
tweenLibrary.scroll.scroll = scroll;
tweenLibrary.scroll.scrollCards = scrollCards;
tweenLibrary.scroll.scrollContinuous = scrollContinuous;
tweenLibrary.element.setImageToCover = setImageToCover;
tweenLibrary.element.setMetaToM23Green = setMetaToM23Green;

// Register click tweens
tweenLibrary.click.dotClick = dotClick;
tweenLibrary.click.fullscreenClick = fullscreenClick;
